export class ChangePassword {
    username: string;
    current_password:  string;
    new_password:  string;
    confirm_password:  string;
}